import z from 'zod';
import { request } from '../../utils/request';
import { StorePrimaryInfo } from '../../schemas/storeGetStartedSchema';

type ReqBody = {
  body: z.infer<typeof StorePrimaryInfo>;
  authToken: string;
};
// THIS HANDLES UPDATING AND CREATION OF NEW STORE
export const saveStore = (req: ReqBody) =>
  request({
    method: 'POST',
    url: `/auth/create-store`,
    headers: {
      Authorization: `Bearer ${req.authToken}`,
    },
    formData: req.body,
    onError: (err) => {
      throw err;
    },
  });
